"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.deleteFolder = exports.updateFolder = exports.createFolder = void 0;

var _reduxObservable = require("redux-observable");

var _actions = require("./actions");

var _requestEntity = _interopRequireDefault(require("settings-ui-sdk/requestEntity"));

var _RequestEpicDescriptor = _interopRequireDefault(require("settings-ui-sdk/RequestEpicDescriptor"));

var _getRequestStatus = _interopRequireDefault(require("settings-ui-sdk/RequestStatuses/getRequestStatus"));

var _RequestStatusTypes = _interopRequireDefault(require("settings-ui-sdk/constants/RequestStatusTypes"));

var _API = _interopRequireDefault(require("./API"));

var createFolder = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.create,
  initiatingActionType: _actions.FolderActionTypes.CREATE_FOLDER,
  requestActions: _actions.CreateFolder,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.FAILED, _RequestStatusTypes.default.SUCCEEDED],
  requestStatusSelector: (0, _getRequestStatus.default)(_actions.FolderActionTypes.CREATE_FOLDER)
}));
exports.createFolder = createFolder;
var updateFolder = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.update,
  initiatingActionType: _actions.FolderActionTypes.UPDATE_FOLDER,
  requestActions: _actions.UpdateFolder,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.FAILED, _RequestStatusTypes.default.SUCCEEDED],
  requestStatusSelector: (0, _getRequestStatus.default)(_actions.FolderActionTypes.UPDATE_FOLDER)
}));
exports.updateFolder = updateFolder;
var deleteFolder = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.remove,
  initiatingActionType: _actions.FolderActionTypes.DELETE_FOLDER,
  requestActions: _actions.DeleteFolder,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.PENDING, _RequestStatusTypes.default.FAILED, _RequestStatusTypes.default.SUCCEEDED],
  requestStatusSelector: (0, _getRequestStatus.default)(_actions.FolderActionTypes.DELETE_FOLDER)
}));
exports.deleteFolder = deleteFolder;

var _default = (0, _reduxObservable.combineEpics)(createFolder, updateFolder, deleteFolder);

exports.default = _default;